import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import {
    APPEARANCE_RANDOM,
    readStoredAppearance,
    resolvePlayTheme,
    storeAppearance,
} from "../lib/appearance";

const WordWheelAppearanceContext = createContext(null);

export function WordWheelAppearanceProvider({ children }) {
    const [appearance, setAppearanceState] = useState(readStoredAppearance);

    const setAppearance = useCallback((next) => {
        const normalized = storeAppearance(next);
        setAppearanceState(normalized);
    }, []);

    const value = useMemo(
        () => ({
            ...resolvePlayTheme(appearance),
            setAppearance,
        }),
        [appearance, setAppearance]
    );

    return (
        <WordWheelAppearanceContext.Provider value={value}>
            {children}
        </WordWheelAppearanceContext.Provider>
    );
}

export function useWordWheelAppearance() {
    const ctx = useContext(WordWheelAppearanceContext);
    if (!ctx) {
        return {
            ...resolvePlayTheme(APPEARANCE_RANDOM),
            setAppearance: () => {},
        };
    }
    return ctx;
}
